const workapi = [

    {


        id: 1,

        logo: "fa fa-download",

        title: "Choose the brand you trust",

        info: "With more than 360 million active users worldwide, PayPal is one of the most recognised and trusted payment service providers. "
    }
    ,
    {
        id: 2,
        logo: "fas fa-chalkboard-teacher",
        
        title: "Satisfy your customers",
        info: "Give your customers the freedom to pay how they want— from nearly anywhere in the world."
    }

    , {


        id: 3,

        logo: "fas fa-donate",
        title: "Be ready to grow",
        info:"Our comprehensive suite of solutions is designed to serve your commerce needs as they change and expand."
    
    },

];

export default workapi;